<ng-container *ngTemplateOutlet="type === 'list' ? list : dropdown" />

<ng-template #list>
  @for (watchlist of watchlists; track trackByWatchlistNumber($index, watchlist)) {
    <div class="td-wb-add-to-watchlist__container">
      <td-wb-divider />
      <button class="td-wb-add-to-watchlist__list-button"
              (click)="addSymbolToWatchlist(watchlist)"
              [disabled]="isDisabled(watchlist)">
        <span [innerText]="watchlist.name"></span>
        @if (isFull(watchlist)) {
          <div class="td-wb-add-to-watchlist__full">
            <td-wb-icon class="td-wb-add-to-watchlist__icon"
                        iconId="warning--small"
                        [inline]="true" />
            <span class="td-wb-add-to-watchlist__sub"
                  translate="tdWb.markets.quote.addtowatchlist.FULL">
            </span>
          </div>
        }
        @if (hasSymbol(watchlist) && !isFull(watchlist)) {
          <div class="td-wb-add-to-watchlist__full">
            <td-wb-icon class="td-wb-add-to-watchlist__icon"
                        iconId="warning--small"
                        [inline]="true" />
            <span class="td-wb-add-to-watchlist__sub"
                  [title]="'tdWb.generic.ATTENTION' | translate"
                  translate="tdWb.markets.quote.addtowatchlist.ALREADY_ADDED">
            </span>
          </div>
        }
      </button>
    </div>
  }
</ng-template>

<ng-template #dropdown>
  <button id="td-wb-add-to-watchlist-overlay"
          class="td-wb-add-to-watchlist__toggle"
          [class.td-wb-add-to-watchlist__toggle-open]="menuOpened"
          [class.td-wb-add-to-watchlist__toggle-compact]="compactView"
          tdWbButton
          tdWbButtonType="secondary"
          [tdWbFlyoutMenuToggle]="addToWatchlistMenu"
          [tdWbFlyoutMenuToggleOverlayPosition]="overlayPosition()"
          [tdWbFlyoutMenuToggleAllowPageScroll]="true"
          [attr.aria-label]="'tdWb.markets.quote.addtowatchlist.ADD_TO_WATCHLIST' | tdWbTranslate">
    <div class="td-wb-add-to-watchlist__toggle-content">
      @if (!(symbolAddedCompleted || symbolAddedFailed)) {
        <div class="td-wb-add-to-watchlist__toggle-text">
          <div class="td-wb-add-to-watchlist__star">
            <td-wb-icon iconId="star-outlined--small" size="18" />
          </div>
          @if (!compactView) {
            <div class="td-wb-add-to-watchlist__text"
                 translate="tdWb.markets.quote.addtowatchlist.ADD_TO_WATCHLIST">
            </div>
          }
        </div>
        <div class="td-wb-add-to-watchlist__arrow"></div>
      } @else {
        <div class="td-wb-add-to-watchlist__toggle-text">
          <div class="td-wb-add-to-watchlist__star">
            <td-wb-icon iconId="star-filled--small"
                        size="18" />
          </div>
          @if (symbolAddedCompleted && !compactView) {
            <div class="td-wb-add-to-watchlist__text"
                 aria-hidden="true"
                 translate="tdWb.markets.quote.addtowatchlist.SUCCESS">
            </div>
          }
          @if (symbolAddedFailed && !compactView) {
            <div class="td-wb-add-to-watchlist__text"
                 aria-hidden="true"
                 translate="tdWb.markets.quote.addtowatchlist.FAILURE">
            </div>
          }
        </div>
        <div class="td-wb-add-to-watchlist__arrow"></div>
      }
    </div>
  </button>

  <td-wb-flyout-menu id="td-wb-flyout-menu-aria-0"
                     #addToWatchlistMenu="tdWbFlyoutMenu"
                     (open)="setMenuToggle()"
                     (close)="setMenuToggle()">
    <div class="td-wb-add-to-watchlist__content">
      @for (watchlist of watchlists; track trackByWatchlistNumber($index, watchlist)) {
        <button tdWbFlyoutMenuItem
                class="td-wb-add-to-watchlist__button"
                (click)="addSymbolToWatchlist(watchlist)"
                [disabled]="isDisabled(watchlist)">
          <span [innerText]="watchlist.name"></span>
          @if (isFull(watchlist)) {
            <div
              class="td-wb-add-to-watchlist__full">
              <td-wb-icon class="td-wb-add-to-watchlist__icon"
                          iconId="warning--small"
                          [inline]="true" />
              <span class="td-wb-add-to-watchlist__sub"
                    translate="tdWb.markets.quote.addtowatchlist.FULL">
              </span>
            </div>
          }
          @if (hasSymbol(watchlist) && !isFull(watchlist)) {
            <div class="td-wb-add-to-watchlist__full">
              <td-wb-icon class="td-wb-add-to-watchlist__icon"
                          iconId="warning--small"
                          [inline]="true" />
              <span class="td-wb-add-to-watchlist__sub"
                    [title]="'tdWb.generic.ATTENTION' | translate"
                    translate="tdWb.markets.quote.addtowatchlist.ALREADY_ADDED">
              </span>
            </div>
          }
        </button>
      }
    </div>
  </td-wb-flyout-menu>
</ng-template>

@if (symbolAddedCompleted) {
  <div class="td-wb-vh"
       role="alert"
       translate="tdWb.markets.quote.addtowatchlist.SUCCESS">
  </div>
}
@if (symbolAddedFailed) {
  <div class="td-wb-vh"
       role="alert"
       translate="tdWb.markets.quote.addtowatchlist.FAILURE">
  </div>
}

